import { useQuery } from '@tanstack/react-query';
import { getUserStatsV2 } from '@/api/stats';

/**
 * Hook to get user statistics v2 with cumulative PnL graph data
 */
export const useStats = (userId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['stats', 'v2', userId],
    queryFn: () => getUserStatsV2(userId),
    enabled: enabled && !!userId,
    staleTime: 10*1000, // 10 seconds
    refetchInterval: false, // Don't auto-refetch, rely on cache
  });
};

